export const REMOTE_API_BASE_URL = import.meta.env.VITE_REMOTE_URL || 'http://localhost:8000/remote'
export const REMOTE_WS_BASE_URL = import.meta.env.VITE_REMOTE_WS_URL || 'ws://localhost:8000/remote'